<p>wo-te-role-auth works!</p>
